import React from "react";

export const SECURE_PASS_TEXT = "SecurePass™";

const SecurePassText = ({ isTrademarked = true, bold = false }) => {
  if (isTrademarked) return <span style={{ fontWeight: bold ? "bold" : "normal" }}>{SECURE_PASS_TEXT}</span>;

  return <span style={{ fontWeight: bold ? "bold" : "normal" }}>SecurePass</span>;
};

export default SecurePassText;
